import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import Landing from "@/pages/Landing";
import Microsite from "@/pages/Microsite";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import CampaignEditor from "@/pages/admin/CampaignEditor";
import { GlimpsePage } from "@/components/glimpse/GlimpseExperience";

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/change-password"
                element={
                  <ProtectedRoute isChangePasswordPage>
                    <AdminChangePassword />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/campaigns/:id"
                element={
                  <ProtectedRoute>
                    <CampaignEditor />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<Landing />} />
              <Route path="/bhagavatam/glimpse" element={<GlimpsePage />} />
              <Route path="/bhagavatam/glimpse/:feelingId" element={<GlimpsePage />} />
              <Route path="/:slug/bhagavatam/glimpse" element={<GlimpsePage />} />
              <Route path="/:slug/bhagavatam/glimpse/:feelingId" element={<GlimpsePage />} />
              <Route path="/:slug" element={<Microsite />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </LanguageProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
